// Author YuJiaBei
// Date 2022-02-08 21:38:24

class EmOpcComputedEventEoce {
constructor({
        id = null,
        eoceIdEoc = '',
        eoceName = '',
        eoceCode = '',
        eoceCodeBda = '',
        eoceIdIesmrs = '',
        eoceExAttrA = '',
        eoceExAttrB = '',
        eoceExAttrC = '',
        eoceExAttrD = '',
        eoceExAttrE = '',
        eoceIdEocA = '',
        eoceIdEocB = '',
        eoceIdEocC = '',
        eoceIdEocD = '',
        eoceIdEocE = '',
        eoceCallbackApi = '',
        eoceEnable = '',
        remark = ''}
= {}) {
    this.id = id;
    this.eoceIdEoc = eoceIdEoc;
    this.eoceName = eoceName;
    this.eoceCode = eoceCode;
    this.eoceCodeBda = eoceCodeBda;
    this.eoceIdIesmrs = eoceIdIesmrs;
    this.eoceExAttrA = eoceExAttrA;
    this.eoceExAttrB = eoceExAttrB;
    this.eoceExAttrC = eoceExAttrC;
    this.eoceExAttrD = eoceExAttrD;
    this.eoceExAttrE = eoceExAttrE;
    this.eoceIdEocA = eoceIdEocA;
    this.eoceIdEocB = eoceIdEocB;
    this.eoceIdEocC = eoceIdEocC;
    this.eoceIdEocD = eoceIdEocD;
    this.eoceIdEocE = eoceIdEocE;
    this.eoceCallbackApi = eoceCallbackApi;
    this.eoceEnable = eoceEnable;
    this.remark = remark;
}
}

function newEntity() {
return new EmOpcComputedEventEoce();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEoc',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEoc',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocNodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocValueType',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocValueType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocEnable',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceCode',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceCodeBda',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceCodeBda',
        sortable: true,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
        }
        },
        {
        key: 'eoceIdIesmrs',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdIesmrs',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
        }
        },
        {
        key: 'eoceExAttrA',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceExAttrA',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceExAttrB',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceExAttrB',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceExAttrC',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceExAttrC',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceExAttrD',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceExAttrD',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceExAttrE',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceExAttrE',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEocA',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEocA',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocAName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocAName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocANodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocANodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEocB',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEocB',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocBName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocBName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocBNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocBNodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEocC',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEocC',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocCName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocCName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocCNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocCNodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEocD',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEocD',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocDName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocDName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocDNodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocDNodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceIdEocE',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceIdEocE',
        sortable: true,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
        }
        },
        {
        key: 'eocEName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocEName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eocENodeId',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eocENodeId',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceCallbackApi',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceCallbackApi',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'eoceEnable',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.eoceEnable',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    eoceIdEocFilter : '',
    eocEnableFilter : '',
    eocNodeIdFilter : '',
    eoceNameFilter : '',
    eoceCodeFilter : '',
    eoceCodeBdaFilter : '',
    eoceIdIesmrsFilter : '',
    eoceExAttrAFilter : '',
    eoceExAttrBFilter : '',
    eoceExAttrCFilter : '',
    eoceExAttrDFilter : '',
    eoceExAttrEFilter : '',
    eoceIdEocAFilter : '',
    eoceIdEocBFilter : '',
    eoceIdEocCFilter : '',
    eoceIdEocDFilter : '',
    eoceIdEocEFilter : '',
    eoceCallbackApiFilter : '',
    eoceEnableFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'eoceIdEocFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEoc',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eocEnableFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eocEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eocNodeIdFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eocNodeId',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceNameFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceCodeFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceCodeBdaFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceCodeBda',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdIesmrsFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdIesmrs',
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceExAttrAFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceExAttrA',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrBFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceExAttrB',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrCFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceExAttrC',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrDFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceExAttrD',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrEFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceExAttrE',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocAFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEocA',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocBFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEocB',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocCFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEocC',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocDFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEocD',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocEFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceIdEocE',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceCallbackApiFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceCallbackApi',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceEnableFilter',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.filter.eoceEnable',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'eoceIdEoc',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEoc',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceName',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceCode',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceCodeBda',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceCodeBda',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'eoceIdIesmrs',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdIesmrs',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'imfEmSicIesmrStatusIesmrs'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceExAttrA',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceExAttrA',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrB',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceExAttrB',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrC',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceExAttrC',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrD',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceExAttrD',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceExAttrE',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceExAttrE',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceIdEocA',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEocA',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceIdEocB',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEocB',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceIdEocC',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEocC',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceIdEocD',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEocD',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceIdEocE',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceIdEocE',
        sortable: true,
        disabled: false,
        form: {
        type: 'treeSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emOpcComputedEoc'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'eoceCallbackApi',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceCallbackApi',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'eoceEnable',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.eoceEnable',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.base.opcClient.emOpcComputedEventEoce.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {EmOpcComputedEventEoce, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
